import { ref, watch, inject } from 'vue'
import { useVirtualizer } from '@tanstack/vue-virtual'

/**
 * Wraps @tanstack/vue-virtual for DataGrid body rows.
 * Uses the page-level QScrollArea element (injected from PageContainer as a
 * reactive ref) so the virtualizer re-attaches its scroll listener after mount.
 * Calls onNearEnd when the virtualizer approaches the last loaded row.
 */
export const useVirtualRows = ({ count, estimateSize, onNearEnd, overscan = 8 }) => {
  const parentRef = ref(null)
  const pageScrollTarget = inject('pageScrollTarget', ref(null))

  const virtualizer = useVirtualizer({
    get count () {
      return count.value ?? 0
    },
    getScrollElement: () => pageScrollTarget.value ?? parentRef.value,
    estimateSize: () => estimateSize?.value ?? 30,
    overscan
  })

  watch(
    () => virtualizer.value.getVirtualItems(),
    items => {
      const last = items.at(-1)
      if (!last || count.value === 0) return
      if (last.index >= count.value - overscan * 2) {
        onNearEnd?.()
      }
    }
  )

  return { parentRef, virtualizer }
}
